// extracted by mini-css-extract-plugin
export default {"productThumbnails":"Z4-z","zoomMode":"_4-z","carousel":"a5-z","slides":"b5-z","slide":"c5-z","slideThumb":"d5-z","nav":"e5-z","fadeIn":"f5-z","mounting":"g5-z","horizontal":"h5-z"};